import { getQuery } from '@i18n-ecom/lib/dist/commonjs/url';
import {
  LearningInfo,
  LearningType,
  RoleType,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { IDENTITY_KEY, Path, ROLE_KEY, RoleTypeMap } from '@/constants';
import { getPopReportQuery } from '@/hooks/usePopQuery';

export const genLocationByLearningInfo = (
  search: string,
  info: LearningInfo,
) => {
  const query = getQuery(search);
  const role = RoleTypeMap[query[ROLE_KEY]?.toString()] || RoleType.Seller;
  const identity = query[IDENTITY_KEY]?.toString();
  const isCourse = info.learning_type === LearningType.Course;
  const idKey = isCourse ? 'learning_id' : 'knowledge_id';
  const popQuery = getPopReportQuery(true);

  return {
    pathname: isCourse ? Path.CourseDetail : Path.Essay,
    search: `${IDENTITY_KEY}=${identity}&${ROLE_KEY}=${role}&${idKey}=${info.learning_id}${
      popQuery ? `&${popQuery}` : ''
    }`,
  };
};
